import { classNames } from 'primereact/utils'
import SmallLoader from '../../loaders/SmallLoader'

export type ActionButtonOptions = { disabled?: boolean; isLoading?: boolean; onClick?: () => void }

export function ActionButtonTemplate({ caption, buttonOptions: { disabled, isLoading, onClick } }: { caption: string; buttonOptions: ActionButtonOptions }) {
    const buttonClassnames = classNames({
        'button-div': true,
        'disabled': disabled || isLoading,
    })

    return (
        <button disabled={disabled || isLoading} onClick={onClick} className={buttonClassnames}>
            {isLoading ? <SmallLoader text="Загрузка..." /> : <>{caption}</>}
        </button>
    )
}


